import { combineReducers } from 'redux';
import LoginReducer from '../../modules/auth/Login/reducer';
import GlobalReducer from './global/reducer';
import RegisterReducer from '../../modules/auth/Register/reducer';
import HomeReducer from '../../modules/main/Home/reducer';
import StoreReducer from '../../modules/main/Store/reducer';
import PromoReducer from '../../modules/main/Promo/reducers';
import HistoryPointReducer from '../../modules/main/HistoryPoint/reducer';
import ReservationReducer from '../../modules/main/Reservation/reducer';
import ForgotPasswordReducer from '../../modules/auth/ForgotPassword/reducer';
import PolicyReducer from '../../modules/main/Policy/reducer';
import ChangePasswordReducer from '../../modules/main/ChangePassword/reducer';
import HistoryTransactionReducer from '../../modules/main/HistoryTransaction/reducer';
import TopUpReducer from '../../modules/main/Topup/reducer';
import FaqReducer from '../../modules/main/Faq/reducer';

const combine = combineReducers({
    global: GlobalReducer,
    LoginReducer,
    RegisterReducer,
    HomeReducer,
    StoreReducer,
    PromoReducer,
    HistoryPointReducer,
    ReservationReducer,
    ForgotPasswordReducer,
    PolicyReducer,
    ChangePasswordReducer,
    HistoryTransactionReducer,
    TopUpReducer,
    FaqReducer
})

export { combine }